import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-me",
  "use": "icon-me-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-me\"><defs><style type=\"text/css\"></style></defs><path d=\"M518 61c246.319 0 446 199.681 446 446S764.319 953 518 953 72 753.319 72 507 271.681 61 518 61z m216.103 520.552H322.588v0.164c0 113.637 92.12 205.758 205.757 205.758s205.758-92.12 205.758-205.758v-0.164z m-342.546-258.47c-38.09 0-68.97 30.879-68.97 68.97 0 38.09 30.88 68.969 68.97 68.969s68.969-30.879 68.969-68.97c0-38.09-30.879-68.969-68.97-68.969z m273.577 0c-38.09 0-68.97 30.879-68.97 68.97 0 38.09 30.88 68.969 68.97 68.969s68.97-30.879 68.97-68.97c0-38.09-30.88-68.969-68.97-68.969z\" p-id=\"12742\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/me.svg
// module id = TJvx
// module chunks = 7